// import axios from "axios";
// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { basePathConfig } from "../../config";
// import errorHandler from "../error/errorHandler";

// // Thunks
// // fetch all labels Data
// export const fetchAccount = createAsyncThunk("account/fetch", async () => {
//   try {
//     const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
//     const accountID = localStorage.getItem("atua");
//     if (!!bearer_token && !!accountID) {
//       const config = {
//         headers: {
//           Authorization: bearer_token,
//         },
//       };
//       const res = await axios.get(
//         `${basePathConfig.baseURL}/onespoc_webhook/account/${accountID}`,
//         config
//       );
//       return await res.data;
//     } else {
//       return { message: "Unauthorized", status: 401 };
//     }
//   } catch (error) {
//     var ErrorData = await errorHandler(error);
//     return await ErrorData;
//   }
// });

// export const STATUSES = Object.freeze({
//   SUCCESS: "success",
//   ERROR: "error",
//   LOADING: "loading",
// });

// export const accountSlice = createSlice({
//   name: "agents",
//   initialState: {
//     data: [],
//     status: STATUSES.SUCCESS,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAccount.pending, (state, action) => {
//         state.status = STATUSES.LOADING;
//       })
//       .addCase(fetchAccount.fulfilled, (state, action) => {
//         state.data = action.payload;
//         state.status = STATUSES.SUCCESS;
//       })
//       .addCase(fetchAccount.rejected, (state, action) => {
//         state.status = STATUSES.ERROR;
//       });
//   },
// });
// export const { setAccount, setStatus } = accountSlice.actions;
// export default accountSlice.reducer;

import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { basePathConfig } from "../../config";
import errorHandler from "../error/errorHandler";

// Thunks
// fetch all labels Data
export const fetchAccount = createAsyncThunk("account/fetch", async () => {
  try {
    const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
    const accountID = localStorage.getItem("atua");
    if (!!bearer_token && !!accountID) {
      const config = {
        headers: {
          Authorization: bearer_token,
        },
      };
      const res = await axios.get(
        `${basePathConfig.baseURL}/app/accounts/${accountID}`,
        config
      );
      return res.data;
    } else {
      return { message: "Unauthorized", status: 401 };
    }
  } catch (error) {
    var ErrorData = await errorHandler(error);
    return ErrorData;
  }
});

export const updateStickySession = createAsyncThunk(
  "account/updateStickySession",
  async (sticky_session) => {
    // ✅ Destructure dispatch properly
    try {
      console.log("Updating sticky_session:", sticky_session);
      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");

      if (!!bearer_token && !!accountID) {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };

        const res = await axios.post(
          `${basePathConfig.baseURL}/super/account/${accountID}/stickysessions`,
          { sticky_session },
          config
        );
        console.log("API Response: ", res.data);

        // ✅ Instead of calling dispatch here, return res.data
        return res.data;
      } else {
        return { message: "Unauthorized", status: 401 };
      }
    } catch (error) {
      var ErrorData = await errorHandler(error);
      throw ErrorData; // ✅ Ensure proper error propagation
    }
  }
);

export const updateStickyLocation = createAsyncThunk(
  "account/updateStickyLocation",
  async (sticky_location) => {
    // ✅ Destructure dispatch properly
    try {
      console.log("Updating sticky_location:", sticky_location);
      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");

      if (!!bearer_token && !!accountID) {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };

        const res = await axios.post(
          `${basePathConfig.baseURL}/super/account/${accountID}/stickylocations`,
          { sticky_location },
          config
        );
        console.log("API Response: ", res.data);

        // ✅ Instead of calling dispatch here, return res.data
        return res.data;
      } else {
        return { message: "Unauthorized", status: 401 };
      }
    } catch (error) {
      var ErrorData = await errorHandler(error);
      throw ErrorData; // ✅ Ensure proper error propagation
    }
  }
);

export const STATUSES = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading",
});

export const accountSlice = createSlice({
  name: "agents",
  // initialState: {
  //     data: [],
  //     status: STATUSES.SUCCESS,
  // },
  initialState: {
    fetchAccountData: { data: {}, status: "", error: {} },
    updateStickySessionData: { data: {}, status: STATUSES.SUCCESS, error: {} },
    updateStickyLocationData: { data: {}, status: STATUSES.SUCCESS, error: {} },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Account Data
      .addCase(fetchAccount.pending, (state) => {
        state.fetchAccountData = {
          status: STATUSES.LOADING,
          data: {},
          error: {},
        };
      })
      .addCase(fetchAccount.fulfilled, (state, action) => {
        console.log("API Response Data:", action.payload);
        if (action.payload.error) {
          state.fetchAccountData = {
            status: STATUSES.ERROR,
            data: {},
            error: action.payload.error,
          };
        } else {
          state.fetchAccountData = {
            status: STATUSES.SUCCESS,
            data: action.payload.data,
            error: {},
          };
        }
      })
      .addCase(fetchAccount.rejected, (state, action) => {
        state.fetchAccountData = {
          status: STATUSES.ERROR,
          data: {},
          error: action.payload,
        };
      })

      // Update Sticky Session
      .addCase(updateStickySession.pending, (state) => {
        state.updateStickySessionData = {
          status: STATUSES.LOADING,
          data: {},
          error: {},
        };
      })
      .addCase(updateStickySession.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.updateStickySessionData = {
            status: STATUSES.ERROR,
            data: {},
            error: action.payload.error,
          };
        } else {
          state.updateStickySessionData = {
            status: STATUSES.SUCCESS,
            data: action.payload,
            error: {},
          };
          state.fetchAccountData.data.sticky_session =
            action.payload.sticky_session;
        }
      })
      .addCase(updateStickySession.rejected, (state, action) => {
        state.updateStickySessionData = {
          status: STATUSES.ERROR,
          data: {},
          error: action.payload,
        };
      })

      // Update Sticky Location
      .addCase(updateStickyLocation.pending, (state) => {
        state.updateStickyLocationData = {
          status: STATUSES.LOADING,
          data: {},
          error: {},
        };
      })
      .addCase(updateStickyLocation.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.updateStickyLocationData = {
            status: STATUSES.ERROR,
            data: {},
            error: action.payload.error,
          };
        } else {
          state.updateStickyLocationData = {
            status: STATUSES.SUCCESS,
            data: action.payload,
            error: {},
          };
          state.fetchAccountData.data.sticky_location =
            action.payload.sticky_location;
        }
      })
      .addCase(updateStickyLocation.rejected, (state, action) => {
        state.updateStickyLocationData = {
          status: STATUSES.ERROR,
          data: {},
          error: action.payload,
        };
      });
  },
});
export const { setAccount, setStatus } = accountSlice.actions;
export default accountSlice.reducer;
